var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 copyright text-center",staticStyle:{"color":"white !important","font-size":"smaller"}},[_vm._v("\n      Copyright © 2018-"+_vm._s(_vm.year)+" All Rights Reserved by Caprico Ltd. v"+_vm._s(_vm.appVersion)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }